import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useRoute } from 'vue-router'

export const useNavbarStore = defineStore('navbarStore', () => {
  const isNavbarShown = ref(true)
  const activeMenuItemIndex = ref(-1)
  const route = useRoute()

  const openNavbar = () => {
    isNavbarShown.value = true
  }

  const closeNavbar = () => {
    isNavbarShown.value = false
  }

  const handleShowNavbar = () => {
    if (route.meta?.layout === 'PageLayout') {
      closeNavbar()
      return
    }

    openNavbar()
  }

  const setActiveMenuItem = (menuItemIndex: number) => {
    activeMenuItemIndex.value = menuItemIndex
  }

  return {
    isNavbarShown,
    activeMenuItemIndex,
    openNavbar,
    closeNavbar,
    handleShowNavbar,
    setActiveMenuItem,
  }
})
